import { ShopManagerInfo } from 'actions/actionTypes';

export const changeShopManagerInfo = (element, value) => ({
    type: ShopManagerInfo.CHANGE_SHOP_MANAGER_INFO,
    payload: { element, value },
});

export const loadShopManagerInfoRequest = () => ({
    type: ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST,
});

export const loadShopManagerInfoRequestSuccess = responseData => ({
    type: ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST_SUCCESS,
    payload: { responseData }, // responseData를 객체로 통일
});

export const loadShopManagerInfoRequestFailure = errorMessage => ({
    type: ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST_FAILURE,
    payload: { errorMessage }, // errorMessage를 객체로 통일
});

export const editShopManagerInfoRequest = (newPassword) => ({
    type: ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST,
    payload: {
        newPassword, // 전달받은 비밀번호를 payload로 전달
    },
});

export const editShopManagerInfoRequestSuccess = responseData => ({
    type: ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST_SUCCESS,
    payload: { responseData }, // responseData를 객체로 통일
});

export const editShopManagerInfoRequestFailure = errorMessage => ({
    type: ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST_FAILURE,
    payload: { errorMessage }, // errorMessage를 객체로 통일
});

// import { ShopManagerInfo } from 'actions/actionTypes';
//
// export const changeShopManagerInfo = (element, value) => ({ type: ShopManagerInfo.CHANGE_SHOP_MANAGER_INFO, payload: { element, value } });
//
// export const loadShopManagerInfoRequest = managerIdx => ({ type: ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST, payload: managerIdx });
// export const loadShopManagerInfoRequestSuccess = responseData => ({ type: ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST_SUCCESS, payload: responseData });
// export const loadShopManagerInfoRequestFailure = errorMessage => ({ type: ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST_FAILURE, payload: errorMessage });
//
// export const editShopManagerInfoRequest = () => ({ type: ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST });
// export const editShopManagerInfoRequestSuccess = responseData => ({ type: ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST_SUCCESS, payload: responseData });
// export const editShopManagerInfoRequestFailure = errorMessage => ({ type: ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST_FAILURE, payload: errorMessage });